import {
  NAV_FLAGS_LOADED,
  NAV_FLAGS_REFRESHED,
  NAV_FLAGS_RESET,
  NAV_KILL_CHECKED,
  NAV_TOUR_SEEN,
} from "./navFlags.types";

// Флаги кабинета. Пишут ShellSwitch (component/navV3/ShellSwitch.jsx) и короткое
// обучение по меню (NavV3Tour.jsx).
//
// navV3 и source — меню на это открытие кабинета. Его решает первый ответ сервера;
// изменение потом применяется только при следующем открытии, чтобы открытая
// страница не перемонтировалась и не теряла введённое.
// navTourSeen — короткое обучение по меню уже показано (с сервера или только что).
// canSeeReviews — последний ответ сервера, пересчитывается при смене магазина.
// killed — общий выключатель «всем старое меню» сработал за это открытие. Он действует
// сразу, а снятие выключателя применяется при следующем открытии кабинета.
// loaded — первый ответ сервера на это открытие уже пришёл.
const navFlagsState = {
  navV3: false,
  canSeeReviews: false,
  source: null,
  navTourSeen: false,
  killed: false,
  loaded: false,
};

export default function navFlagsReducer(state = navFlagsState, action) {
  switch (action.type) {
    case NAV_FLAGS_LOADED: {
      const { navV3, source, canSeeReviews, navTourSeen } = action.payload || {};
      let next = state;

      if (typeof canSeeReviews === "boolean" && canSeeReviews !== state.canSeeReviews) {
        next = { ...next, canSeeReviews };
      }

      if (!state.loaded && typeof navV3 === "boolean") {
        next = { ...next, navV3, source: source || null, navTourSeen: next.navTourSeen || navTourSeen === true, loaded: true };
      }

      return next;
    }

    case NAV_FLAGS_REFRESHED: {
      const canSeeReviews = action.payload?.canSeeReviews;
      if (typeof canSeeReviews !== "boolean" || canSeeReviews === state.canSeeReviews) {
        return state;
      }
      return { ...state, canSeeReviews };
    }

    case NAV_KILL_CHECKED:
      if (action.payload !== true || state.killed) return state;
      return { ...state, killed: true };

    case NAV_TOUR_SEEN:
      if (state.navTourSeen) return state;
      return { ...state, navTourSeen: true };

    case NAV_FLAGS_RESET:
      return navFlagsState;

    default:
      return state;
  }
}
